<!-- <div class="imgbutton"><img (click)="showFAQ()" src="./assets/images/icon-faq1.png" width="45px" height="45px"/></div>-->
<div class="imgbutton">
    <button type="button" (click)="showFAQ()" class="btn btn-responsive btn-general">Have a Question?</button>                           
</div>